import { render, staticRenderFns } from "./PublicProfileHero.vue?vue&type=template&id=1f947f7f&"
import script from "./PublicProfileHero.vue?vue&type=script&lang=js&"
export * from "./PublicProfileHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports